export const LARGE_COMPACT_VIDEO_SIZE = 200;
export const SMALL_COMPACT_VIDEO_SIZE = 100;

export const getCompactVideoStyle = (platform, isTabletDevice) => {
  const size =
    platform === 'web' || isTabletDevice
      ? LARGE_COMPACT_VIDEO_SIZE
      : SMALL_COMPACT_VIDEO_SIZE;

  return {width: size, height: size};
};
